import { create } from 'zustand';

interface SceneState {
    fov: number;
    showAxes: boolean;
    autoRotate: boolean;
    cameraResetVersion: number;
    setFov: (fov: number) => void;
    setShowAxes: (visible: boolean) => void;
    setAutoRotate: (value: boolean) => void;
    triggerResetCamera: () => void;
}

export const useSceneStore = create<SceneState>((set) => ({
    fov: 75,
    showAxes: false,
    autoRotate: false,
    cameraResetVersion: 0,
    setFov: (fov) => set({ fov }),
    setShowAxes: (visible) => set({ showAxes: visible }),
    setAutoRotate: (value) => set({ autoRotate: value }),
    triggerResetCamera: () => set((state) => ({ cameraResetVersion: state.cameraResetVersion + 1 })),
}));
